<template>
  <div class="layout-container">
    <header class="layout-header">
      <!-- 左侧图标+标题 -->
      <div class="nav-item logo">
        <img src="@/assets/logo.png" alt="Logo" class="logo-img" />
        <span class="logo-title">光衍熔纤助手管理平台</span>
      </div>

      <!-- 居中导航栏 -->
      <div class="nav-tabs">
        <div
          v-for="(tab, index) in navTabs"
          :key="index"
          class="nav-item"
          :class="{ 'active-nav-item': currentTab === index }"
          @click="selectTab(index)"
        >
          <el-icon><component :is="tab.icon" /></el-icon>
          {{ tab.title }}
        </div>
      </div>

      <!-- 右侧用户头像+名称 -->
      <el-dropdown class="user-info" @command="handleCommand">
        <div class="user-info-content">
          <el-avatar :src="user.avatar" class="user-avatar"></el-avatar>
          <span>{{ user.username }}</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item disabled>角色：{{ user.roleText }}</el-dropdown-item>
            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </header>

    <!-- 主体内容区域 -->
    <main class="layout-content">
      <router-view />
    </main>
    
    <!-- 备案信息底部栏 -->
    <footer class="beian-footer">
      <div class="beian-content">
        <div class="beian-item">
          <img src="@/assets/guohui.png" alt="国徽" class="beian-icon">
          <span>粤公网安备44030502010225号</span>
        </div>
        <div class="beian-item">
          <span>粤ICP备2023077234号-4</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { webAdminLogout } from "@/api/webadmin";
import {
  Search,
  Upload,
  Monitor,
  DataBoard,
  User,
  Key,
  Operation,
  Picture,
  Setting,
  List,
} from "@element-plus/icons-vue";

export default {
  name: "MainLayout",
  components: {
    Search,
    Upload,
    Monitor,
    DataBoard,
    User,
    Key,
    Operation,
    Picture,
    Setting,
    List,
  },
  setup() {
    const router = useRouter();
    const currentTab = ref(parseInt(window.location.pathname.slice(1)) || 0);
    const navTabs = [
      { title: "检测管理", icon: Search },
      { title: "我导入的设备", icon: Upload },
      { title: "设备管理", icon: Monitor },
      { title: "设备类型管理", icon: DataBoard },
      { title: "用户管理", icon: User },
      { title: "账号管理", icon: Key },
      { title: "帮助内容管理", icon: Operation },
      { title: "广告管理", icon: Picture },
      { title: "其他配置", icon: Setting },
      { title: "系统操作日志", icon: List },
    ];

    const user = ref({
      avatar: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      name: "未登录",
      role: ""
    });

    // 检查登录状态
    onMounted(() => {
      const userInfo = localStorage.getItem('userInfo');
      if (!userInfo) {
        router.push('/login');
      } else {
        user.value = JSON.parse(userInfo);
        // 将数字角色转换为文本显示
        if (user.value.role === 0) {
          user.value.roleText = "管理员";
        } else if (user.value.role === 1) {
          user.value.roleText = "员工";
        } else if (user.value.role === 2) {
          user.value.roleText = "维修工程师";
        } else {
          user.value.roleText = "未知角色";
        }
      }
    });

    // 处理下拉菜单命令
    const handleCommand = async (command) => {
      if (command === 'logout') {
        try {
          await webAdminLogout();
          localStorage.removeItem('userInfo');
          router.push('/login');
          ElMessage.success('已退出登录');
        } catch (error) {
          ElMessage.error('退出登录失败');
        }
      }
    };

    const selectTab = (index) => {
      currentTab.value = index;
      router.push({ path: `/${index}` });
    };

    // 监听路由变化
    router.afterEach((to) => {
      const index = parseInt(to.path.slice(1));
      if (!isNaN(index)) {
        currentTab.value = index;
      }
    });

    return {
      currentTab,
      navTabs,
      user,
      selectTab,
      handleCommand,
    };
  },
};
</script>

<style scoped>
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-tabs {
  display: flex;
  flex-direction: row;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 20px 15px;
  font-size: small;
  transition: background-color 0.3s;
}

.nav-item:hover {
  background-color: #f5f5f5;
}

.active-nav-item {
  color: #409eff;
  /* font-weight: bold; */
  font-size: small;
  background-color: #ecf5ff;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0 30px; /* 增加右边的距离 */
}

.user-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 10px;
}

.layout-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 图标样式调整 */
.el-icon {
  margin-right: 10px;
  font-size: 16px;
  vertical-align: middle;
}

.logo {
  margin-right: 50px;
  pointer-events: none; /* 禁用鼠标事件 */
}

.logo-img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.logo-title {
  font-size: 18px;
  font-weight: bold;
}
.user-info-content {
  display: flex;
  align-items: center;
}

/* 备案信息底部栏样式 */
.beian-footer {
  padding: 15px 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: transparent;
  border: none;
}

.beian-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap;
}

.beian-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.beian-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .beian-content {
    flex-direction: column;
    gap: 10px;
  }
  
  .beian-footer {
    padding: 10px 0;
    font-size: 11px;
  }
}
</style>
